



























import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  fetchInvestProList,
  updateIsStatus,
  saveIsProList,
} from '@/api/card/investCard'
import { CommonMudule } from '@/store/modules/common'
import TsTable from '@/components/TsTable/TsTable.vue'
import { singleHead } from '@/views/newPension/pensionCard/investCard/utils/index'
import NewFooter from '@/views/newPension/components/newFooter'
import { BtnList } from '@/types/common/btn'
import { SaveInvestPro } from '@/types/card/investCard'
import EmptyTable from '@/components/emptyTable/index.vue'
@Component({
  name: 'inputPage',
  components: {
    TsTable,
    NewFooter,
    EmptyTable,
  },
})
export default class extends Vue {
  @Prop() type!: string | null;
  @Prop() tabInfo!: {};
  @Prop() getTopChartAndTableFn!: Function;
  singleHead = singleHead;
  isProList: { data: SaveInvestPro[] } = {
    data: [],
  };

  get updateItemId () {
    const enItem = this.isProList.data.find(item => item.enabled)
    return enItem && enItem.id
  }

  nextPage (btnInfo: BtnList) {
    if (btnInfo.btnType === 'ok') {
      this.getTopChartAndTableFn()
    }
    this.getTopChartAndTableFn()
    this.$emit('on-click', 'back', 2)
  }

  async onUpdateIsStatus () {
    if (!this.updateItemId) {
      this.$message.error('至少有一个为开启状态')
      return false
    }
    const res = await updateIsStatus({
      customerId: CommonMudule.customerId,
      id: this.updateItemId as string,
      storyLineType: 'Pension',
    })
    if (res.statusCode === 0 && res.data) {
      this.$message.success('操作成功')
    }
  }

  handleTableTitleBtn (p1: string, p2: SaveInvestPro) {
    if (p2) {
      switch (p1) {
        case 'edit':
          this.edit(p2)
          break
        case 'del':
          this.delete(p2)
          break
      }
    }
  }

  edit (p2: SaveInvestPro) {
    this.$emit('on-click', 'setting', p2)
  }

  async delete (p2: SaveInvestPro) {
    console.log('p2', p2)
    p2.deleted = true
    p2.storyLineType = 'Pension'
    p2.autoInvestActions = []
    p2.singleActions = []
    const res = await saveIsProList(p2)
    if (res.statusCode === 0 && res.data) {
      this.$message.success('删除成功')
      this.onFetchList()
    }
  }

  addGroup () {
    this.$emit('on-click', 'edit', 'create')
  }

  switchChange (scope: { $index: number; row: { id: string } }) {
    const { row } = scope
    console.log(' this.isProList.data', this.isProList.data)

    this.isProList.data.forEach((item: SaveInvestPro) => {
      if (item.enabled) {
        if (item.id === row.id) {
          console.log('item', item)
        } else {
          item.enabled = false
        }
      } else {
        item.enabled = false
      }
    })
    this.onUpdateIsStatus()
    console.log('switchChange scope', scope)
  }

  async onFetchList () {
    const res = await fetchInvestProList({
      customerId: CommonMudule.customerId,
      storyLineType: 'Pension',
    })
    if (res.statusCode === 0 && res.data) {
      this.isProList.data = res.data
      console.log('res onFetchList', res)
    }
  }

  created () {
    this.onFetchList()
  }
}
